import React from "react";

interface TitleProps {
  uppercase?: boolean
  children: React.ReactNode
}

const Title = ({ uppercase, children }: TitleProps) => {
  return (
    <h1 className={`text-xl font-bold flex justify-start h-1/10 items-center pl-1 border-b-2 border-b-black/25 ${uppercase && 'uppercase'}`}>
      {children}
    </h1>
  );
};

export default Title;
